module.exports = "<div class=\"breadcrumb\">\r\n  <a\r\n    class=\"level\"\r\n    [class.inactive]=\"!name\"\r\n    [routerLink]=\"'/' + topLevelName\"\r\n  >{{ topLevelName | translate }}</a>\r\n  <a *ngFor=\"let level of levels; let i = index\" class=\"level\" [routerLink]=\"generateLink(i)\">{{generateName(i)}}</a>\r\n  <a *ngIf=\"name\" class=\"level inactive\">{{name}}</a>\r\n</div>\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/common/components/BreadcrumbComponent/breadcrumb.component.html
// module id = ./src/app/common/components/BreadcrumbComponent/breadcrumb.component.html
// module chunks = main